import { useParams } from 'react-router-dom'
import { deleteRequest, getRequest, postRequest } from '../../../services/base'
import Button from '../../common/Button'
import { useContext, useEffect, useRef, useState } from 'react'
import { NavContext } from '../../../context/global_context'
import MemosRow from './TracerMemosRow'
import NoRecordsFound from '../../common/NoRecordsFound'
import TracerMemos from './TracerMemos'
import {
  MemoContext,
  SELECT_DTC_MEMO,
  SET_DTC_MEMO_LIST,
  SET_MEMOS_DATE,
  SHOW_FETCH_MEMO_POPUP,
} from './context/context'
import InputText from '../../common/InputText'
import MemoHeader from './MemoHeader'
import DtcMemoFormPopup from './form'
import Pagination from '../../common/Pagination'

const Memos = () => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(MemoContext)
  const [navState, navDispatch] = useContext(NavContext)

  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({})
  const currentUrl = useRef(
    `/api/dtc_memos/?vehicle=${vehicle}&search=${search}`
  )

  useEffect(() => {
    getDtcMemos()
  }, [])

  const getDtcMemos = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Fetching memos...',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(currentUrl.current)
    setPagination(res.pagination)
    dispatch({ type: SET_DTC_MEMO_LIST, data: res.results })

    navDispatch({
      type: 'loader',
      data: {
        caption: '',
        showLoader: false,
      },
      notification: {},
    })
  }

  const deleteDtcMemos = async (memo_id) => {
    if (window.confirm('Are you sure to delete DTC Memo') == true) {
      let res = await deleteRequest(
        `/api/dtc_memos/${memo_id}/?vehicle=${vehicle}`
      )
      getDtcMemos()
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'DTC Memos Successfully deleted!',
        },
      })
    }
  }

  const valideBeforeImport = () => {
    if (
      window.confirm(`Are you sure want to import memo from tracer`) == true
    ) {
      dispatch({ type: SHOW_FETCH_MEMO_POPUP, data: true })
    }
  }

  return (
    <>
      <TracerMemos
        getListData={() => {
          getDtcMemos()
        }}
      />
      {state.show_memo_popup && (
        <DtcMemoFormPopup
          getListData={() => {
            getDtcMemos()
          }}
        />
      )}

      <div className="flex flex-col py-3 space-y-6 w-full">
        <div className="flex justify-between items-center text-white bg-tracer-dark-blue rounded py-2 px-6">
          <div className="w-4/12">
            <div className="flex space-x-4 items-center">
              <InputText
                type="search"
                onChange={(e) => {
                  setSearch(e)
                }}
                wrapperClass={`pl-0`}
                name="search_dtcs_memo"
                placeholder={`Search DTC Memos`}
                value={search}
              />
              <Button
                type="submit"
                className={`cursor-pointer btn`}
                onClick={(e) => {
                  currentUrl.current = `/api/dtc_memos/?vehicle=${vehicle}&search=${search}`
                  getDtcMemos()
                }}
                text={'Search'}
              />
            </div>
          </div>

          <div className="flex space-x-4 items-center">
            <InputText
              type="datetime-local"
              onChange={(e) => {
                dispatch({ type: SET_MEMOS_DATE, data: e })
              }}
              wrapperClass={`pl-0`}
              name="memo_fetch_Date"
              placeholder={`Select Date to Fetch Tracer Data`}
              value={state?.memos_date}
            />
            <Button
              type="submit"
              className={`cursor-pointer btn`}
              onClick={(e) => {
                valideBeforeImport()
              }}
              text={'Import All From Tracer'}
            />
            <Button
              type="submit"
              className={`cursor-pointer btn`}
              onClick={(e) => {
                dispatch({
                  type: SELECT_DTC_MEMO,
                  data: { selected_memo: {}, show_memo_popup: true },
                })
              }}
              text={'Create New Memo'}
            />
          </div>
        </div>
      </div>
      <div className="container">
        <div className="font-light">
          <MemoHeader />
          {state?.memo_list?.map((memo, index) => {
            return (
              <MemosRow
                {...memo}
                key={`memo-${index}`}
                index={index}
                showAction={false}
                onDelete={() => {
                  deleteDtcMemos(memo.id)
                }}
              />
            )
          })}
          {state?.memo_list?.length < 1 && <NoRecordsFound />}
          <div className="py-6">
            <Pagination
              context={pagination}
              onClickNext={(e) => {
                currentUrl.current = e
                getDtcMemos()
              }}
              onClickPrev={(e) => {
                currentUrl.current = e
                getDtcMemos()
              }}
            />
          </div>{' '}
        </div>
      </div>
    </>
  )
}

export default Memos
